<template>
  <div class="loading-overlay">
    <div class="card">
      <div class="card-body">
        <LoadingSpinner :text="text" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { PropType, computed } from 'vue';
  import LoadingSpinner from './LoadingSpinner.vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = defineProps({
    text: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const text = computed(() => (props.text != '' ? props.text : t('common.loadingText')));
</script>

<style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1056; /* Modal has z-index 1055 */
  }
</style>
